module.exports = __webpack_public_path__ + "static/media/mhw-logo.a38cbc55.png";